module.exports = __webpack_public_path__ + "img/calendar-tab.f2e914ba.svg";